import styled from 'styled-components';

import arrow_right from '../../../../assets/image/arrow_right/arrow_right.webp';
import arrow_right2x from '../../../../assets/image/arrow_right/arrow_right@2x.webp';
import arrow_right3x from '../../../../assets/image/arrow_right/arrow_right@3x.webp';
import attendance from '../../../../assets/image/attendance/attandance.webp';
import attendance2x from '../../../../assets/image/attendance/attendance@2x.webp';
import attendance3x from '../../../../assets/image/attendance/attendance@3x.webp';

const arrow_right_list = [arrow_right, arrow_right2x, arrow_right3x];

export { arrow_right_list };

export const Container = styled.div`
	position: relative;
	background-color: #fff;
	max-width: 10rem;
	margin: 0rem 1rem;
	${({ theme }) => theme.common.wh('100%')};
	${({ theme }) => theme.common.flex()};
	background-image: url(${attendance3x});
	background-position: center;
	background-size: 100% 120%;
	background-repeat: no-repeat;
	opacity: ${({ isLoading }) => (isLoading ? 0.6 : 1)};
	transition: opacity 0.3s ease;

	button {
		border: none;
		border-radius: 12px;
		background-color: transparent;
		padding: 0.5rem 2rem 0.5rem 2rem;
		${({ theme }) => theme.common.wh('100%')};
		${({ theme }) => theme.common.flex('row', 'center', 'center')};
		cursor: ${({ isLoading }) => (isLoading ? 'wait' : 'pointer')};

		&:disabled {
			cursor: wait;
		}

		img {
			transform: rotate(90deg);
			display: inline-block; /* inline 요소로 표시되도록 함 */
			${({ theme }) => theme.common.wh('auto', '50%')};
		}
	}
`;

export const OptionsWrap = styled.ul`
	position: absolute;
	top: 2.8rem;
	left: 0;
	list-style-type: none;
	//margin-top: 0.1rem;
	z-index: 1;
	overflow: hidden;
	transition: 0.3s ease-in;
	box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.16);
	font-size: 1.4rem;
	max-height: ${({ click }) => (click ? '50rem' : '0rem')};
	//border: 1px solid ${({ theme }) => theme.color.border};
	${({ theme }) => theme.common.wh('100%', 'auto')};
	${({ theme }) => theme.common.flex('column', 'center', 'space-between')};

	li {
		position: relative;
		background-color: #fff;
		padding: 0.7rem;
		transition: 0.1s;
		border-bottom: 1px dashed ${({ theme }) => theme.color.border};
		&:hover {
			class: 'hovered';
			cursor: pointer;
		}
		${({ theme }) => theme.common.wh('100%')};
		${({ theme }) => theme.common.flex()};

		&:last-child {
			border: none;
		}
	}
`;

export const Circle = styled.span`
	//position: absolute;
	display: inline-block; /* inline-block 요소로 설정하여 크기 지정 가능 */
	height: 100%; /* 부모(li)의 높이에 100%로 설정하여 맞춤 */
	vertical-align: middle; /* 수직 중앙 정렬 */
	padding-left: 0.5rem;

	&:before {
		content: '';
		display: block; /* block 요소로 설정하여 크기 및 스타일 조절 가능 */
		border-radius: 50%; /* 원형으로 만들기 위해 border-radius 설정 */
		position: absolute; /* 절대 위치 지정 */
		left: 10%; /* 왼쪽 정렬 */
		top: 50%; /* 수직 중앙 정렬 */
		transform: translateY(-50%); /* 수직 중앙 정렬을 위한 translateY 설정 */
		aspect-ratio: 1 / 1;
		height: 50%;
		background-color: ${({ color }) => color && color};
	}
`;

export const LoadingSpinner = styled.div`
	display: inline-block;
	width: 1.6rem;
	height: 1.6rem;
	border: 2px solid #f3f3f3;
	border-top: 2px solid #3498db;
	border-radius: 50%;
	animation: spin 1s linear infinite;

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
`;
